import dynamic, { DynamicOptionsLoadingProps } from 'next/dynamic';
import { FallbackLoader } from '@/components/fallbackLoader';
import type { ActivatePendingPatientDialogProps } from './ActivatePendingPatientDialog';
import type { CreateFollowUpEventDialogProps } from '@/components/dialogs/CreateFollowUpEventDialog';
import type { PlanFollowUpDialogProps } from '@/components/dialogs/PlanFollowUpDialog';

const DynamicLoader = (loadingProps: DynamicOptionsLoadingProps) => (
  <FallbackLoader
    fallbackProps={loadingProps}
    minWidth={{ xs: 'unset', md: 600 }}
    minHeight={400}
  />
);

export const AddDocumentDialog = dynamic(
  () => import('./AddDocumentDialog').then((mod) => mod.AddDocumentDialog),
  {
    ssr: false,
    loading: DynamicLoader
  }
);

export const NlpCategorySelectDialog = dynamic(
  () =>
    import('./NlpCategorySelectDialog').then(
      (mod) => mod.NlpCategorySelectDialog
    ),
  {
    ssr: false,
    loading: DynamicLoader
  }
);

export const UploadDocumentQrDialog = dynamic(
  () =>
    import('./UploadDocumentQrDialog').then(
      (mod) => mod.UploadDocumentQrDialog
    ),
  {
    ssr: false,
    loading: DynamicLoader
  }
);

export const ActivatePendingPatientDialog =
  dynamic<ActivatePendingPatientDialogProps>(
    () =>
      import('./ActivatePendingPatientDialog').then(
        (mod) => mod.ActivatePendingPatientDialog
      ),
    {
      ssr: false,
      loading: DynamicLoader
    }
  );

export const RegistrationSuccessDialog = dynamic(
  () =>
    import('./RegistrationSuccessDialog').then(
      (mod) => mod.RegistrationSuccessDialog
    ),
  {
    ssr: false,
    loading: DynamicLoader
  }
);

export const CreateFollowUpEventDialog =
  dynamic<CreateFollowUpEventDialogProps>(
    () =>
      import('./CreateFollowUpEventDialog').then(
        (mod) => mod.CreateFollowUpEventDialog
      ),
    {
      ssr: false,
      loading: DynamicLoader
    }
  );

export const PlanFollowUpDialog = dynamic<PlanFollowUpDialogProps>(
  () => import('./PlanFollowUpDialog').then((mod) => mod.PlanFollowUpDialog),
  {
    ssr: false,
    loading: DynamicLoader
  }
);

export const ConventionStatusDialog = dynamic(
  () =>
    import('./ConventionStatusDialog').then(
      (mod) => mod.ConventionStatusDialog
    ),
  {
    ssr: false,
    loading: DynamicLoader
  }
);

export const SnippetFormDialog = dynamic(
  () => import('./SnippetFormDialog').then((mod) => mod.SnippetFormDialog),
  {
    ssr: false,
    loading: DynamicLoader
  }
);

export * from './TextAreaDialog';
